/* eslint-disable no-unused-vars */
import { Button, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import TemplatePage from "./TemplatePage";
import { flare } from "@flareapp/js";

const CustomReportTemplateList = ({ selected, setSelected }) => {
  const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const { business, userDetails } = useSelector((state) => state.user);

  const [data, setData] = useState([]);
  const [ownData, setOwnData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(Number(searchParams.get("limit")) || 10);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLimit(Number(searchParams.get("limit")) || 10);
    setPage(Number(searchParams.get("page")) || 1);
  }, [searchParams]);

  const getTemplateList = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(endpoint.get_customReport_template_list, {
        withCredentials: true,
        params: {
          limit,
          page,
          // business,
        },
      });
      setData(response.data);
      setTotal(response.count);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getMyReportTemplateList = async () => {
    try {
      if (!isLoading) {
        setIsLoading(true);
        const response = await api.get(endpoint.my_customReport_template, {
          params: {
            limit,
            page,
          },
        });
        setOwnData(response.data);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTemplateList();
  }, [page, limit, business]);

  useEffect(() => {
    document.title = `${appConfig.name} - Report Template List`;
    getMyReportTemplateList();
  }, []);

  return (
    <div>
      {/* <div className="px-md-3 mt-3"> */}
      <Spin spinning={isLoading}>
        <div>
          {/* <div className="border p-3"> */}
          {/* <h5>Report List</h5> */}
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <label className="az-content-label">Generate Report</label>
              <span className="d-block py-2">Select A Report Template</span>
            </div>
            <div className="col-md-4 d-flex justify-content-end p-0">
              <Link to="/report-template-list?mode=create">
                <Button icon={<FaPlus />} type="primary">
                  Create Report Template
                </Button>
              </Link>
            </div>
          </div>
          <hr className="mt-0 mb-5" />

          <Row lg={6} md={6} sm={4} xs={2} xxs={1} className="align-content-between g-2">
            {Array.isArray(data) && data.length > 0 ? (
              data.map((item) => (
                <Col key={item._id} onClick={() => setSelected(item._id)}>
                  <TemplatePage data={item} selected={selected === item._id} />
                </Col>
              ))
            ) : (
              <p>No data found</p>
            )}
          </Row>

          {![userRole.superAdmin, userRole.businessAdmin].includes(userDetails.role) && (
            <div className="mt-4">
              <b className="mb-2 d-block"> Own Template </b>

              <Row lg={6} md={6} sm={4} className="align-content-between g-2">
                {Array.isArray(ownData) && ownData.length > 0 ? (
                  ownData.map((item) => (
                    <Col key={item._id} onClick={() => setSelected(item._id)}>
                      <TemplatePage data={item} selected={selected === item._id} picture="/images/report_demo.png" />
                    </Col>
                  ))
                ) : (
                  <p>No data found</p>
                )}
              </Row>
            </div>
          )}
        </div>
      </Spin>
    </div>
  );
};

export default CustomReportTemplateList;

CustomReportTemplateList.propTypes = {
  selected: PropTypes.array,
  setSelected: PropTypes.func.isRequired,
};
